// Reviewed display-copy phrases. Placeholder values are customer data and stay untouched.
export const supplementArabicTranslations: Record<string, string> = {
  'Confirm approval':'تأكيد الموافقة',
  'Confirm rejection':'تأكيد الرفض',
  'Decision reason':'سبب القرار',
  'A reason is required for rejection or approval across branches.':'السبب مطلوب للرفض أو للموافقة على طلب من فرع آخر.',
  'Rejection reason is required.':'سبب الرفض مطلوب.',
  'Cross-branch approval reason is required.':'سبب الموافقة على طلب من فرع آخر مطلوب.',
  'Unable to apply this approval action. Please review log details and retry.':'تعذر تنفيذ الموافقة. راجع تفاصيل الطلب قبل إعادة المحاولة.',
  'Unable to reject this approval action. Please retry.':'تعذر تنفيذ الرفض. أعد المحاولة.',
  'Some requests were not processed. Review the remaining requests individually.':'لم يتم تنفيذ بعض الطلبات. راجع الطلبات المتبقية كل طلب على حدة.',
  'Student data changed. Review the latest data before saving your draft.': 'تغيّرت بيانات الطالب. راجع أحدث البيانات قبل حفظ مسودتك.',
  'Review latest data': 'مراجعة أحدث البيانات',
  'Payment date': 'تاريخ الدفع',
  'Recorded date': 'تاريخ التسجيل',
  'Former employee': 'موظف سابق',
  'Search employees...': 'ابحث عن موظف...',
  'No matching employees': 'لا يوجد موظفون مطابقون للبحث',
  'Sales attribution requires review. The receipt is saved without assigning an unverified Sales owner.': 'إسناد البيع محتاج مراجعة. الإيصال محفوظ من غير احتساب البيع لموظف غير مثبت.',
  'Students Directory': 'دليل الطلاب',
  'Showing {0} results': 'عرض {0} نتيجة',
  'Table view': 'عرض الجدول',
  'Cards view': 'عرض الكروت',
  'Table': 'جدول',
  'Cards': 'كروت',
  '{0} per page': '{0} في الصفحة',
  'Active filters': 'الفلاتر المختارة',
  'Advanced Filters': 'فلاتر متقدمة',
  'Apply Filters': 'تطبيق الفلاتر',
  'Clear All': 'مسح الكل',
  'Open Student Profile': 'فتح ملف الطالب',
  'Remove {0}: {1}': 'إزالة {0}: {1}',
  'Alternate Phones (optional)': 'أرقام إضافية (اختياري)',
  'Phone used with Sales': 'رقم التواصل مع السيلز',
  'Receipt saved. Sales attribution could not be completed. Check the customer and salesperson.': 'تم تسجيل الإيصال، لكن لم يكتمل ربطه بالسيلز. راجع بيانات العميل والموظف المسؤول.',
  'No due date': 'مفيش موعد نهائي',
  'Target': 'الهدف',
  'Source file': 'ملف المصدر',
  'No grading': 'بدون تصحيح',
  'Other Income': 'إيراد إضافي',
  'Branch Financial Request': 'طلب مالي للفرع',
  'Void Request': 'طلب إلغاء',
  'Danger Action': 'إجراء حساس',
  'Saturday': 'السبت',
  'Sunday': 'الأحد',
  'Monday': 'الاثنين',
  'Tuesday': 'الثلاثاء',
  'Wednesday': 'الأربعاء',
  'Thursday': 'الخميس',
  'Friday': 'الجمعة',
  '{0} days': '{0} يوم',
  'Exam imported successfully.': 'تم استيراد الامتحان بنجاح.',
  'Import is running...': 'جارٍ استيراد الامتحان...',
  'Checking import status...': 'جارٍ مراجعة حالة الاستيراد...',
  'Import stopped.': 'توقف الاستيراد.',
  'Student status': 'حالة الطالب',
  'Group status': 'حالة المجموعة',
  "Alternate Phones": "الأرقام البديلة",
  "Qualification": "المؤهل",
  "Job": "الوظيفة",
  "Student Code": "كود الطالب",
  "Created Time": "وقت التسجيل",
  "Registration Branch": "فرع التسجيل",
  "Acquisition Source": "مصدر العميل",
  "Not Provided": "غير مسجل",
  "Not Verified": "غير متحقق منه",
  "Request Cancellation": "طلب إلغاء",
  "New student comment": "تعليق جديد للطالب",
  "Registration": "التسجيل",
  "Registration ID": "رقم التسجيل",
  "Course ID": "معرّف الكورس",
  "Course Payments": "مدفوعات الكورس",
  "Additional Services Paid": "الخدمات الإضافية المدفوعة",
  "Needs reconciliation": "يحتاج مراجعة الربط",
  "Not attended yet": "لم يبدأ الحضور",
  "Not assigned": "غير محدد",
  "Not fully recorded": "غير مسجل بالكامل",
  "Total Payments": "إجمالي المدفوعات",
  "Total Refunds": "إجمالي الاستردادات",
  "Current Balance": "الرصيد الحالي",
  "Customer ID": "معرّف العميل",
  "Agreed Price": "السعر المتفق عليه",
  "Remaining Amount": "المبلغ المتبقي",
  "Attended Course": "كورس الحضور",
  "Receipt Number": "رقم الإيصال",
  "Refunded Amount": "المبلغ المسترد",
  "Payment Date": "تاريخ الدفع",
  "Payment Branch": "فرع الدفع",
  "Grouped": "منضم لمجموعة",
  'Language Center sections': 'أقسام مركز اللغات',
  'Review workload': 'متابعة التصحيح والمراجعة',
  'Approved result': 'معتمدة',
  'Grading in progress': 'جاري التصحيح',
  'Manual grading needed': 'تحتاج تصحيح يدوي',
  'Needs review': 'تحتاج مراجعة',
  'Not submitted': 'لم يُسلّم',
  'Approve result': 'اعتماد النتيجة',
  'Reopen review': 'إعادة فتح المراجعة',
  'Review answers and scores': 'مراجعة الإجابات والدرجات',
  'Search by student or exam name': 'ابحث باسم العميل أو الامتحان',
  'Counts match the current searches.': 'الأعداد تخص النتائج المطابقة للبحث الحالي.',
  'Total: {0}': 'الإجمالي: {0}',
  'Finish grading all answers before approving this placement test.': 'كمّل تصحيح كل الإجابات قبل اعتماد اختبار تحديد المستوى.',
  'The team has approved this placement result.': 'الفريق اعتمد نتيجة اختبار تحديد المستوى.',
  'The system result is a suggestion. Review the answers and scores before approval.': 'نتيجة السيستم مقترحة. راجع الإجابات والدرجات قبل الاعتماد.',
  'Review and approve': 'مراجعة واعتماد',
  '# Sessions': 'عدد الحصص',
  '% complete': '% مكتمل',
  '% of total': '% من الإجمالي',
  '(Check policy)': '(راجع السياسة)',
  '(HTTP': '(HTTP',
  '(Optional)': '(اختياري)',
  '(Planned)': '(مخطط)',
  '(empty)': '(فاضي)',
  '(optional)': '(اختياري)',
  '(required)': '(مطلوب)',
  ') to': ') إلى',
  '). A reason and confirmation are required; existing approval rules apply.': '). لازم تكتب السبب وتأكد؛ قواعد الموافقة الحالية سارية.',
  '). Existing approval rules apply.': '). قواعد الموافقة الحالية سارية.',
  '+ Option': '+ اختيار',
  '- Due': '- مستحق',
  '- Group #': '- مجموعة رقم',
  '. Legacy comments appear across courses.': '. التعليقات القديمة بتظهر في كل الكورسات.',
  '. The change applies immediately and super reception will be notified.': '. التغيير بيتطبق فورًا وهيتبعت تنبيه لمشرف الاستقبال.',
  '/ 10 minimum characters': '/ 10 حروف على الأقل',
  '/14 digits': '/14 رقم',
  '/20 minimum characters': '/20 حرف على الأقل',
  '1. Enter the refund amount': '1. اكتب مبلغ الاسترداد',
  '14 digits': '14 رقم',
  '2. Approval reason': '2. سبب الموافقة',
  '6:00 PM - 8:00 PM': '6:00 م - 8:00 م',
  ': Attendance mode mismatch: student attendance and group delivery require review.': ': طريقة الحضور مش متطابقة: راجع حضور الطالب وطريقة تقديم المجموعة.',
  ': Finished': ': خلص',
  '; open tasks page for the full list.': '؛ افتح صفحة المهام عشان تشوف القائمة كاملة.',
  'A course invoice already exists. A new free course invoice is blocked.': 'فيه فاتورة للكورس بالفعل. مينفعش تصدر فاتورة مجانية جديدة للكورس.',
  'A group cannot start without an assigned instructor. Unassigned groups can be saved as Planned.': 'المجموعة مينفعش تبدأ من غير مدرس محدد. تقدر تحفظها كمخططة لحد ما تحدد المدرس.',
  'AI Import': 'استيراد بالذكاء الاصطناعي',
  'AI Pending': 'في انتظار نتيجة الذكاء الاصطناعي',
  'AI grading is still running. Scores will update automatically when grading finishes.': 'التصحيح بالذكاء الاصطناعي لسه شغال. الدرجات هتتحدث تلقائيًا لما يخلص.',
  'Absent:': 'غايب:',
  'Accounting records the payout separately after the money has been returned.': 'الحسابات بتسجل الصرف بشكل منفصل بعد رجوع الفلوس.',
  'Acknowledging...': 'جاري تأكيد الاستلام...',
  'Action, employee, subject, ID...': 'الإجراء، الموظف، الموضوع، المعرّف...',
  'Actions for {0}': 'إجراءات {0}',
  'Active:': 'نشط:',
  'Add Comment': 'إضافة تعليق',
  'Add Consultation Slot': 'إضافة موعد استشارة',
  'Add Course + Invoice': 'إضافة كورس وفاتورة',
  'Add Option': 'إضافة اختيار',
  'Add Section': 'إضافة قسم',
  'Add one or more tasks and send them to super reception.': 'ضيف مهمة أو أكتر وابعتها لمشرف الاستقبال.',
  'Add students to group': 'إضافة طلاب للمجموعة',
  'Add tasks to your queue. They become active immediately.': 'ضيف مهام لقائمتك. هتتفعل فورًا.',
  'Add to combined PDF': 'إضافة لملف PDF المجمع',
  'Add {0} Student{1}': 'إضافة {0} طالب{1}',
  'Add {0} to the combined PDF': 'إضافة {0} لملف PDF المجمع',
  'Adding...': 'جاري الإضافة...',
  'Additional / Placement Income (': 'دخل إضافي / تحديد مستوى (',
  'Additional Package Levels': 'مستويات إضافية للباقة',
  'Additional service': 'خدمة إضافية',
  'Adds sequential levels after {0}. Maximum {1}.': 'بيضيف مستويات متتالية بعد {0}. الحد الأقصى {1}.',
  'After this course receipt: Course Payments': 'بعد إيصال الكورس ده: مدفوعات الكورس',
  'All Daily Reports': 'كل التقارير اليومية',
  'All branches': 'كل الفروع',
  'All reports have been read.': 'كل التقارير اتقرت.',
  'Amount Paid Now': 'المبلغ المدفوع دلوقتي',
  'Amount from {0}': 'المبلغ من {0}',
  'Amount matches the approved refund.': 'المبلغ مطابق للاسترداد الموافق عليه.',
  'Amount:': 'المبلغ:',
  'Anonymous': 'غير معروف',
  'Answer:': 'الإجابة:',
  'Answered:': 'تمت الإجابة:',
  'Approval note': 'ملاحظة الموافقة',
  'Approve & Add to Group': 'موافقة وإضافة للمجموعة',
  'Approve & Forward': 'موافقة وتحويل',
  'Approve (': 'موافقة (',
  'Approve Join Request': 'الموافقة على طلب الانضمام',
  'Approve Payment': 'الموافقة على الدفع',
  'Approve invoice': 'الموافقة على الفاتورة',
  'Approve {0}': 'الموافقة على {0}',
  'Approved by {0}': 'وافق عليه {0}',
  'Approved cancellation': 'إلغاء موافق عليه',
  'Approved:': 'موافق عليه:',
  'Approving...': 'جاري الموافقة...',
  'Arabian Academy Finance System': 'نظام الحسابات في Arabian Academy',
  'Ask super reception or the general manager to link the original invoices for this request before accounting records it as paid.': 'اطلب من مشرف الاستقبال أو المدير العام يربط الفواتير الأصلية بالطلب قبل ما الحسابات تسجله كمدفوع.',
  'Assigned To': 'متسند لـ',
  'Assignment #': 'تكليف رقم',
  'Audience:': 'الفئة المستهدفة:',
  'Audit Exam:': 'مراجعة الامتحان:',
  'Audit Exam: {0}': 'مراجعة الامتحان: {0}',
  'Awaiting super review': 'في انتظار مراجعة مشرف الاستقبال',
  'Balanced': 'متوازن',
  'Because you are super reception, submitting this will mark the task as done immediately.': 'بما إنك مشرف الاستقبال، إرسال ده هيعلّم المهمة كمكتملة فورًا.',
  'Branch locked': 'الفرع مقفول للتعديل',
  'Branch needs review': 'الفرع محتاج مراجعة',
  'Branch:': 'الفرع:',
  'By:': 'بواسطة:',
  'Calendar day {0}': 'يوم {0} في التقويم',
  'Campaign:': 'الحملة:',
  'Cancellation rejected:': 'الإلغاء اترفض:',
  'Cancellation request rejected:': 'طلب الإلغاء اترفض:',
  'Cancellation {0}': 'إلغاء {0}',
  'Capacity:': 'السعة:',
  'Categories used': 'التصنيفات المستخدمة',
  'Categorize the file first, then upload PDFs, audio, video, or links.': 'حدد تصنيف الملف الأول، وبعدين ارفع PDF أو صوت أو فيديو أو روابط.',
  'Check that every amount is a whole number within the receipt balance.': 'اتأكد إن كل مبلغ رقم صحيح ومش أكبر من رصيد الإيصال.',
  'Choose': 'اختار',
  'Choose a group': 'اختار مجموعة',
  'Choose a language and level using the filters above, then click Load Materials to view existing content.': 'اختار اللغة والمستوى من الفلاتر اللي فوق، وبعدين اضغط تحميل المواد عشان تشوف المحتوى الموجود.',
  'Choose purpose': 'اختار الغرض',
  'Choose source file': 'اختار الملف المصدر',
  'Choose the amount to take from each receipt below. The total must equal': 'حدد المبلغ من كل إيصال تحت. لازم الإجمالي يساوي',
  'Clear visible': 'مسح الظاهر',
  'Clone {0}': 'نسخ {0}',
  'Close menu': 'إغلاق القائمة',
  'Close {0}': 'إغلاق {0}',
  'Collapse sidebar': 'تصغير القائمة الجانبية',
  'Comment:': 'التعليق:',
  'Comments are linked to': 'التعليقات مرتبطة بـ',
  'Compact attendance overview for': 'ملخص الحضور لـ',
  'Complete': 'مكتمل',
  'Complete the related work, then mark the task done.': 'خلّص الشغل المرتبط بالمهمة، وبعدين علّمها كمكتملة.',
  'Configure the report parameters below. The report will include all income sources (student invoices + additional income) and expenses for the selected period.': 'حدد إعدادات التقرير تحت. التقرير هيشمل كل مصادر الدخل (فواتير الطلاب والدخل الإضافي) والمصروفات خلال الفترة المختارة.',
  'Confirm Add to Group': 'تأكيد الإضافة للمجموعة',
  'Confirm Finished': 'تأكيد انتهاء الكورس',
  'Confirm the student has finished this course. Its waiting request will be closed. Other courses keep their status. Move this course to Waiting to reopen it.': 'أكد إن الطالب خلّص الكورس ده. طلب الانتظار بتاعه هيتقفل، وحالة الكورسات التانية هتفضل زي ما هي. انقل الكورس للانتظار عشان تفتحه تاني.',
  'Connecting...': 'جاري الاتصال...',
  'Consultation Queue (': 'طابور الاستشارات (',
  'Consultation slot {0}': 'موعد الاستشارة {0}',
  'Continue to Invoice': 'كمّل للفاتورة',
  'Correct:': 'صحيح:',
  'Cost center:': 'مركز التكلفة:',
  'Could not load certificates.': 'مقدرناش نحمّل الشهادات.',
  'Could not load groups.': 'مقدرناش نحمّل المجموعات.',
  'Could not load student details.': 'مقدرناش نحمّل تفاصيل الطالب.',
  'Could not load student history.': 'مقدرناش نحمّل سجل الطالب.',
  'Course / Program': 'الكورس / البرنامج',
  'Course Interests (': 'الاهتمامات بالكورسات (',
  'Course Name': 'اسم الكورس',
  'Course balance unavailable. Confirm the course agreement before collecting a course payment.': 'رصيد الكورس مش متاح. أكد اتفاق الكورس قبل ما تحصّل دفعة للكورس.',
  'Course fully paid. Additional services are still available.': 'الكورس مدفوع بالكامل. الخدمات الإضافية لسه متاحة.',
  'Course payment': 'دفعة الكورس',
  'Course payment amount': 'مبلغ دفعة الكورس',
  'Course payment amount (EGP)': 'مبلغ دفعة الكورس (جنيه)',
  'Course:': 'الكورس:',
  'Create': 'إنشاء',
  'Create Group': 'إنشاء مجموعة',
  'Create New Program': 'إنشاء برنامج جديد',
  'Create Task': 'إنشاء مهمة',
  'Create folder': 'إنشاء مجلد',
  'Create invoices, track previous payments, and record notes in one workflow.': 'أنشئ الفواتير وتابع المدفوعات السابقة وسجل الملاحظات من مكان واحد.',
  'Create speaking and writing prompts.': 'أنشئ تعليمات أسئلة المحادثة والكتابة.',
  'Create tasks, assign to reception users, and monitor progress in real-time. Tasks auto-complete as reception users perform actions.': 'أنشئ مهام وأسندها لموظفين الاستقبال وتابع التقدم لحظيًا. المهام بتكتمل تلقائيًا لما الموظفين ينفذوا الإجراءات المطلوبة.',
  'Create your personal task list and send it to super reception for approval.': 'أنشئ قائمة مهامك وابعتها لمشرف الاستقبال للموافقة.',
  'Create your personal task list. Super reception tasks are approved immediately.': 'أنشئ قائمة مهامك. مهام مشرف الاستقبال بيتوافق عليها فورًا.',
  'Created from': 'اتعمل من تاريخ',
  'Created to': 'اتعمل لحد تاريخ',
  'Created:': 'اتعمل:',
  'Creating folder': 'جاري إنشاء المجلد',
  'Creating...': 'جاري الإنشاء...',
  'Creating…': 'جاري الإنشاء…',
  'Current Registration Branch:': 'فرع التسجيل الحالي:',
  'Current level:': 'المستوى الحالي:',
  'Current progress': 'التقدم الحالي',
  'Current queue:': 'الطابور الحالي:',
  'Current total:': 'الإجمالي الحالي:',
  'Date:': 'التاريخ:',
  'Default Meeting Link': 'رابط الاجتماع الأساسي',
  'Default for the group; each session can override it.': 'الرابط الأساسي للمجموعة؛ تقدر تحدد رابط مختلف لكل حصة.',
  'Default: {0}': 'الأساسي: {0}',
  'Delete comment': 'حذف التعليق',
  'Delete option {0}': 'حذف الاختيار {0}',
  'Delete question {0}': 'حذف السؤال {0}',
  'Delete {0}': 'حذف {0}',
  'Deleting...': 'جاري الحذف...',
  'Deleting…': 'جاري الحذف…',
  'Detailed': 'تفصيلي',
  'Detect comprehension passages and linked questions.': 'تحديد قطع الفهم والأسئلة المرتبطة بيها.',
  'Download PDF': 'تنزيل PDF',
  'Download PDF Report': 'تنزيل التقرير PDF',
  'Download image': 'تنزيل الصورة',
  'Duplicate contact': 'بيانات تواصل مكررة',
  'Duration is calculated from start/end time. Sessions are calculated from course hours.': 'المدة بتتحسب من وقت البداية والنهاية. الحصص بتتحسب من ساعات الكورس.',
  'EGP / Refunded:': 'جنيه / المسترد:',
  'EGP ·': 'جنيه ·',
  'EGP — set a due date in the invoice screen.': 'جنيه — حدد تاريخ الاستحقاق من شاشة الفاتورة.',
  'EGP)': 'جنيه)',
  'EGP.': 'جنيه.',
  'EGP. Current balance is the remaining amount across course accounts.': 'جنيه. الرصيد الحالي هو المبلغ المتبقي في حسابات الكورسات.',
  'EGP. Linking invoices does not send another payment.': 'جنيه. ربط الفواتير مش بيعمل دفعة تانية.',
  'EGP. Open the student invoice to set a due date.': 'جنيه. افتح فاتورة الطالب عشان تحدد تاريخ الاستحقاق.',
  'EGP. Review the schedule before collecting.': 'جنيه. راجع جدول الأقساط قبل التحصيل.',
  'Edit Consultation Slot': 'تعديل موعد الاستشارة',
  'Edit Exam #{0}': 'تعديل الامتحان رقم {0}',
  'Edit Task': 'تعديل المهمة',
  'Edit group': 'تعديل المجموعة',
  'Editing Program': 'تعديل البرنامج',
  'Email Not Provided': 'الإيميل مش متسجل',
  'Enter amount in Egyptian Pounds.': 'اكتب المبلغ بالجنيه المصري.',
  'Enter amount, e.g. 1205': 'اكتب المبلغ، مثلًا 1205',
  'Enter the actual service amount. Service revenue does not change the course balance.': 'اكتب مبلغ الخدمة الفعلي. إيراد الخدمة مش بيغير رصيد الكورس.',
  'Enter the recipient details manually; the certificate still gets an official number and permanent record.': 'اكتب بيانات المستلم يدويًا؛ الشهادة هيبقى ليها رقم رسمي وسجل دائم.',
  'Enter the recipient full name': 'اكتب اسم المستلم بالكامل',
  'Enter valid dates as dd/mm/yyyy. From must not be after To.': 'اكتب تواريخ صحيحة بالصيغة dd/mm/yyyy. تاريخ البداية مينفعش يبقى بعد تاريخ النهاية.',
  'Enter valid whole amounts.': 'اكتب مبالغ صحيحة من غير كسور.',
  'Enter {0} description': 'اكتب وصف {0}',
  'Entry to request for void:': 'القيد المطلوب إلغاؤه:',
  'Entry to void:': 'القيد اللي هيتلغي:',
  'Error Loading Students': 'مشكلة في تحميل الطلاب',
  'Error:': 'خطأ:',
  'Exam #': 'امتحان رقم',
  'Exam Attempt #{0}': 'محاولة الامتحان رقم {0}',
  'Example: A1.1 - Unit 1': 'مثال: A1.1 - الوحدة 1',
  'Example: Group notes - Week 1': 'مثال: ملاحظات المجموعة - الأسبوع 1',
  "Example: Verified the student's original receipt for this course refund.": 'مثال: تم التحقق من إيصال الطالب الأصلي لاسترداد مبلغ الكورس ده.',
  'Expand sidebar': 'توسيع القائمة الجانبية',
  'Expected: {0} EGP': 'المتوقع: {0} جنيه',
  'Expense details': 'تفاصيل المصروف',
  'Expenses (': 'المصروفات (',
  'Explain why these original receipts belong to this refund. Use at least 10 characters.': 'وضح ليه الإيصالات الأصلية دي تخص الاسترداد ده. اكتب 10 حروف على الأقل.',
  'Explain why this request is rejected...': 'وضح سبب رفض الطلب...',
  'Extract MCQs and answer choices.': 'استخراج أسئلة الاختيار من متعدد واختيارات الإجابة.',
  'FREE OF CHARGE': 'بدون مقابل',
  'FREE OF CHARGE · Original {0} · Waiver {1}': 'بدون مقابل · الأصلي {0} · الإعفاء {1}',
  'Failed': 'فشل',
  'Failed to load': 'مقدرناش نحمّل البيانات',
  'Failed to load consultation slots.': 'مقدرناش نحمّل مواعيد الاستشارات.',
  'Failed to load course interests.': 'مقدرناش نحمّل الاهتمامات بالكورسات.',
  'Failed to load group join requests.': 'مقدرناش نحمّل طلبات الانضمام للمجموعات.',
  'Failed to load group students.': 'مقدرناش نحمّل طلاب المجموعة.',
  'Failed to load placement payments.': 'مقدرناش نحمّل مدفوعات تحديد المستوى.',
  'Failed to load refund requests.': 'مقدرناش نحمّل طلبات الاسترداد.',
  'Failed to load sales consultation queue.': 'مقدرناش نحمّل طابور استشارات المبيعات.',
  'Failed to load summary': 'مقدرناش نحمّل الملخص',
  'Failed to load summer training workspace': 'مقدرناش نحمّل مساحة التدريب الصيفي',
  'Failed to load task.': 'مقدرناش نحمّل المهمة.',
  'Fetching real materials from reception records.': 'جاري تحميل المواد الفعلية من سجلات الاستقبال.',
  'Finish the task already in progress before starting another one.': 'خلّص المهمة اللي شغالة قبل ما تبدأ واحدة تانية.',
  'First': 'الأول',
  'Flag unsupported PDF images for manual review.': 'تحديد صور PDF غير المدعومة للمراجعة اليدوية.',
  'For a different course use Add Course + Invoice in the student profile.': 'لكورس مختلف، استخدم إضافة كورس وفاتورة من ملف الطالب.',
  'For missing correct answers, mark the intended option in the edit form.': 'لو الإجابة الصحيحة ناقصة، حدد الاختيار المقصود من نموذج التعديل.',
  'Found': 'اتلاقى',
  'Free-of-charge and remaining-balance waivers are issued automatically by the employee who submits the receipt.': 'الإعفاء بدون مقابل والإعفاء من الرصيد المتبقي بيصدروا تلقائيًا باسم الموظف اللي بيقدم الإيصال.',
  'From:': 'من:',
  'General': 'عام',
  'General comment': 'تعليق عام',
  'Generate Report': 'إنشاء التقرير',
  'Generated by:': 'أنشأه:',
  'Generated:': 'اتعمل:',
  'Generating PDF...': 'جاري تجهيز PDF...',
  'Generating Report...': 'جاري تجهيز التقرير...',
  'Good afternoon,': 'مساء الخير،',
  'Group #': 'مجموعة رقم',
  'Group Details': 'تفاصيل المجموعة',
  'Group Status:': 'حالة المجموعة:',
  'Group name not recorded': 'اسم المجموعة مش متسجل',
  'Group {0} details': 'تفاصيل المجموعة {0}',
  'Guest': 'ضيف',
  'Hide': 'إخفاء',
  'How students attend': 'طريقة حضور الطلاب',
  'ID:': 'المعرّف:',
  'ID: {0}': 'المعرّف: {0}',
  'If set, updates the total course fee and recalculates remaining balance.': 'لو اتحدد، بيحدث سعر الكورس بالكامل وبيعيد حساب الرصيد المتبقي.',
  'Import with AI': 'استيراد بالذكاء الاصطناعي',
  'Income': 'الدخل',
  'Income by category': 'الدخل حسب التصنيف',
  'Income categories': 'تصنيفات الدخل',
  'Income details': 'تفاصيل الدخل',
  'Installment #': 'قسط رقم',
  'Installment schedule exceeds the remaining balance by': 'جدول الأقساط أكبر من الرصيد المتبقي بمبلغ',
  'Interest #': 'اهتمام رقم',
  'Interest {0}': 'الاهتمام {0}',
  'Internal Student ID:': 'المعرّف الداخلي للطالب:',
  'Invalid Group ID': 'معرّف المجموعة مش صحيح',
  'Invalid Session ID': 'معرّف الحصة مش صحيح',
  'Invalid attempt id': 'معرّف المحاولة مش صحيح',
  'Invalid exam id': 'معرّف الامتحان مش صحيح',
  'Invalid group ID.': 'معرّف المجموعة مش صحيح.',
  'Invalid student id': 'معرّف الطالب مش صحيح',
  'Invoice #': 'فاتورة رقم',
  'Invoice availability could not be loaded. Reopen this request before linking receipts.': 'مقدرناش نحمّل الفواتير المتاحة. افتح الطلب تاني قبل ربط الإيصالات.',
  'Invoice data could not be loaded.': 'مقدرناش نحمّل بيانات الفاتورة.',
  'Invoice details are temporarily unavailable.': 'تفاصيل الفاتورة مش متاحة مؤقتًا.',
  'Invoice must have linked student, total price, and no pending edit.': 'لازم الفاتورة تكون مرتبطة بطالب، وليها سعر إجمالي، ومفيهاش تعديل قيد الانتظار.',
  'Issued By:': 'أصدره:',
  'Issuing...': 'جاري الإصدار...',
  'Joined:': 'انضم:',
  'Keep the daily view simple. Advanced filters stay hidden until needed.': 'الفلاتر المتقدمة مخفية لحد ما تحتاجها.',
  'Lang:': 'اللغة:',
  'Language Package Levels': 'مستويات باقة اللغة',
  'Last': 'الأخير',
  'Last marked:': 'آخر تسجيل:',
  'Last payment:': 'آخر دفعة:',
  'Last receipt:': 'آخر إيصال:',
  'Last {0} Days': 'آخر {0} يوم',
  'Lead selected a sales consultation slot and needs reception follow-up.': 'العميل المحتمل اختار موعد استشارة من المبيعات ومحتاج متابعة الاستقبال.',
  'Legacy — needs classification': 'قديم — محتاج تصنيف',
  'Level:': 'المستوى:',
  'Link the original payment receipts so accounting can complete this refund.': 'اربط إيصالات الدفع الأصلية عشان الحسابات تقدر تكمل الاسترداد.',
  'Linked:': 'مرتبط:',
  'LinkedIn URL': 'رابط LinkedIn',
  'Loading student {0}': 'جاري تحميل الطالب {0}',
  'Log #{0} details': 'تفاصيل السجل رقم {0}',
  'Manage quarter groups with clean cards instead of a wide spreadsheet table.': 'إدارة مجموعات الربع السنوي من البطاقات.',
  'Mark option {0} {1}': 'تحديد الاختيار {0} {1}',
  'Marking...': 'جاري التسجيل...',
  'Max Eligible:': 'أقصى مبلغ مسموح:',
  'Menu': 'القائمة',
  'Mobile navigation': 'التنقل على الموبايل',
  'Monitor system actions, approvals, and employee activity from one clean audit workspace.': 'تابع إجراءات النظام والموافقات ونشاط الموظفين من سجل المراجعة.',
  'Move {0}': 'نقل {0}',
  'Moving...': 'جاري النقل...',
  'Net payments:': 'صافي المدفوعات:',
  'No note recorded for this request.': 'مفيش ملاحظة متسجلة للطلب ده.',
  'No phone': 'مفيش رقم موبايل',
  'No phone number': 'مفيش رقم موبايل',
  'No reason recorded': 'مفيش سبب متسجل',
  'No receipt': 'مفيش إيصال',
  'No reports found': 'مفيش تقارير',
  'No results for "': 'مفيش نتائج لـ "',
  'No room assigned': 'مفيش قاعة محددة',
  'No students found for "': 'مفيش طلاب لـ "',
  'No submission summary was provided.': 'مفيش ملخص للتسليم.',
  'No suitable groups found': 'مفيش مجموعات مناسبة',
  'No unread reports found': 'مفيش تقارير لسه متقرتش',
  'Not Required': 'مش مطلوب',
  'Not Sent': 'متبعتش',
  'Not assigned yet': 'لسه متسندش',
  'Not available': 'مش متاح',
  'Not in a Group': 'مش في مجموعة',
  'Not set yet': 'لسه متحددش',
  'Note to super': 'ملاحظة لمشرف الاستقبال',
  'Now Working': 'شغال دلوقتي',
  'Oldest': 'الأقدم',
  'One PDF{0}': 'ملف PDF واحد{0}',
  'Open WhatsApp': 'فتح WhatsApp',
  'Open WhatsApp for {0}': 'فتح WhatsApp لـ {0}',
  'Open the assigned workflow and complete the required task.': 'افتح الصفحة المطلوبة وخلّص المهمة المسندة ليك.',
  'Optional internal note for this approval...': 'ملاحظة داخلية اختيارية للموافقة دي...',
  'Orange/Red is calculated using days before begin date + current fill ratio.': 'البرتقالي والأحمر بيتحسبوا حسب الأيام المتبقية قبل البداية ونسبة اكتمال المجموعة الحالية.',
  'Original Course/Service Value': 'قيمة الكورس / الخدمة الأصلية',
  'Original Outstanding Balance': 'الرصيد المستحق الأصلي',
  'Over Scheduled': 'الأقساط المجدولة أعلى من الرصيد',
  'Overpayment: excess reduces next installment(s)': 'زيادة في الدفع: الزيادة بتقلل القسط أو الأقساط الجاية',
  'Override Placement Test': 'تجاوز نتيجة اختبار تحديد المستوى',
  'Overriding...': 'جاري التجاوز...',
  'PDF report': 'تقرير PDF',
  'Package complete — renew before': 'الباقة خلصت — جدد قبل',
  'Package levels must be between 1 and': 'عدد مستويات الباقة لازم يكون من 1 لـ',
  'Package starts at:': 'الباقة بتبدأ من:',
  'Package:': 'الباقة:',
  'Page {0}': 'صفحة {0}',
  'Page {0}/{1}': 'صفحة {0}/{1}',
  'Partial payment: deficit added to next installment': 'دفعة جزئية: المبلغ الناقص بيتضاف للقسط الجاي',
  'Partially Refunded': 'مسترد جزئيًا',
  'Passage Text': 'نص القطعة',
  'Past Session - Editing Enabled': 'حصة سابقة - التعديل متاح',
  'Pay Now': 'ادفع دلوقتي',
  'Pay Scheduled Installment': 'دفع القسط المجدول',
  'Paying...': 'جاري الدفع...',
  'Payment approval:': 'الموافقة على الدفع:',
  'Payment approved and official invoice': 'الدفع اتوافق عليه والفاتورة الرسمية',
  'Payment details are temporarily unavailable.': 'تفاصيل الدفع مش متاحة مؤقتًا.',
  'Pending approval:': 'في انتظار الموافقة:',
  'Phone Not Provided': 'رقم الموبايل مش متسجل',
  'Planning Suggestion': 'اقتراح التخطيط',
  'Polling': 'جاري متابعة التحديثات',
  'Preparing {0}/{1}': 'جاري تجهيز {0}/{1}',
  'Preparing...': 'جاري التجهيز...',
  'Prompt / Instructions': 'المطلوب / التعليمات',
  'Q': 'س',
  'Question': 'سؤال',
  'Questions (': 'الأسئلة (',
  'Questions Missing Correct Option (': 'أسئلة من غير اختيار صحيح (',
  'Questions With Multiple Correct Options (': 'أسئلة فيها أكتر من اختيار صحيح (',
  'Queue item #': 'عنصر الطابور رقم',
  'Queue item {0}': 'عنصر الطابور {0}',
  'Quick Receipt': 'إيصال سريع',
  'Quick search is visible. Heavy planning filters stay inside More Filters.': 'البحث السريع ظاهر. فلاتر التخطيط موجودة داخل فلاتر أكتر.',
  'Ready students may already be in this group, or no one currently matches the course and access rules.': 'الطلاب الجاهزين ممكن يكونوا في المجموعة دي بالفعل، أو مفيش طالب حاليًا مطابق للكورس وقواعد الوصول.',
  'Ready to register': 'جاهز للتسجيل',
  'Ready to upload': 'جاهز للرفع',
  'Receipt details are temporarily unavailable.': 'تفاصيل الإيصال مش متاحة مؤقتًا.',
  'Receipt for invoice #{0}': 'إيصال الفاتورة رقم {0}',
  'Receipt for {0}': 'إيصال {0}',
  'Receipt image attached': 'صورة الإيصال مرفقة',
  'Reception menu': 'قائمة الاستقبال',
  'Reception overview': 'ملخص الاستقبال',
  'Recipient name': 'اسم المستلم',
  'Reduce the allocation by {0} EGP': 'قلل المبلغ الموزع بمقدار {0} جنيه',
  'Refund details are temporarily unavailable.': 'تفاصيل الاسترداد مش متاحة مؤقتًا.',
  'Registering...': 'جاري التسجيل...',
  'Reject (': 'رفض (',
  'Reject Join Request': 'رفض طلب الانضمام',
  'Rejecting...': 'جاري الرفض...',
  'Remaining amount: {0} EGP': 'المبلغ المتبقي: {0} جنيه',
  'Remaining balance: {0}.': 'الرصيد المتبقي: {0}.',
  'Remove student from group': 'إزالة الطالب من المجموعة',
  'Remove {0} from {1}? If the class has started and the student has no other group, they will be marked Did Not Complete.': 'إزالة {0} من {1}؟ لو الدراسة بدأت والطالب مش في مجموعة تانية، حالته هتتسجل لم يكمل.',
  'Renewal Package Price': 'سعر تجديد الباقة',
  'Reorder question {0}': 'تغيير ترتيب السؤال {0}',
  'Report #': 'تقرير رقم',
  'Report {0}': 'التقرير {0}',
  'Request #': 'طلب رقم',
  'Request {0}': 'الطلب {0}',
  'Requested payment method: {0}.': 'طريقة الدفع المطلوبة: {0}.',
  'Requesting...': 'جاري إرسال الطلب...',
  'Requests (': 'الطلبات (',
  'Required Students': 'الطلاب المطلوبين',
  'Resend Password Email': 'إعادة إرسال إيميل كلمة السر',
  'Resending...': 'جاري إعادة الإرسال...',
  'Resolving access...': 'جاري التحقق من الوصول...',
  'Review all recorded income for the selected period.': 'راجع كل الدخل المتسجل خلال الفترة المختارة.',
  'Review and manage sales invoices from salesmen.': 'راجع وأدر فواتير موظفين المبيعات.',
  'Review salesman payment requests and move approved payments into official invoices.': 'راجع طلبات دفع موظفين المبيعات وحوّل المدفوعات الموافق عليها لفواتير رسمية.',
  'Review the required steps and update progress from here.': 'راجع الخطوات المطلوبة وحدث التقدم من هنا.',
  "Review today's scheduled sessions before attendance starts.": 'راجع حصص النهارده المجدولة قبل تسجيل الحضور.',
  'Revoke certificate': 'إلغاء صلاحية الشهادة',
  'Revoked': 'ملغية الصلاحية',
  'Revoked certificates cannot be downloaded': 'الشهادات الملغية الصلاحية مينفعش تتنزل',
  'Revoking...': 'جاري إلغاء الصلاحية...',
  'Room or lab': 'قاعة أو معمل',
  'S': 'ط',
  'Sales ({0})': 'المبيعات ({0})',
  'Sales{0}': 'المبيعات{0}',
  'Save Alert Conditions': 'حفظ شروط التنبيه',
  'Save Comment': 'حفظ التعليق',
  'Save Exam': 'حفظ الامتحان',
  'Save Structure': 'حفظ الهيكل',
  'Save Waiting': 'حفظ الانتظار',
  'Save original invoice allocation': 'حفظ توزيع الفواتير الأصلية',
  'Schedule a new attendance session for': 'جدولة حصة حضور جديدة لـ',
  'Schedule rules': 'قواعد الجدولة',
  'Score (0-': 'الدرجة (0-',
  'Scored:': 'تم التصحيح:',
  'Search & Filter Students': 'بحث وفلترة الطلاب',
  'Search and filter students': 'بحث وفلترة الطلاب',
  'Search by name, code, or phone...': 'ابحث بالاسم أو الكود أو الموبايل...',
  'Search {0}': 'البحث في {0}',
  'Search {0} by student or exam name...': 'ابحث في {0} باسم الطالب أو الامتحان...',
  'Search {0}…': 'البحث في {0}…',
  'Section {0}': 'القسم {0}',
  'Section {0} audio': 'صوت القسم {0}',
  'See how much was spent and where it went.': 'راجع المبالغ المصروفة وأوجه الصرف.',
  'Select': 'اختار',
  'Select Scope to Begin': 'اختار النطاق عشان تبدأ',
  'Select Training Type': 'اختار نوع التدريب',
  'Select log {0}': 'اختيار السجل {0}',
  'Select option': 'اختار اختيار',
  'Sending...': 'جاري الإرسال...',
  'Sent': 'اتبعت',
  'Service price / amount': 'سعر / مبلغ الخدمة',
  'Service price / amount (EGP)': 'سعر / مبلغ الخدمة (جنيه)',
  'Session Date Has Passed': 'تاريخ الحصة فات',
  'Session start:': 'بداية الحصة:',
  'Session {0}': 'الحصة {0}',
  'Show': 'عرض',
  'Signed-in students': 'الطلاب اللي سجلوا الدخول',
  'Slot #': 'موعد رقم',
  'Some answers need manual review before the result is final.': 'فيه إجابات محتاجة مراجعة يدوية قبل اعتماد النتيجة النهائية.',
  'Sort students': 'ترتيب الطلاب',
  'Specific Group': 'مجموعة محددة',
  'Spending by category': 'المصروفات حسب التصنيف',
  'Start live session': 'بدء الحصة المباشرة',
  "Start with pending work, check today's sessions, then open your assigned tasks. No management noise.": 'ابدأ بالشغل المعلق، راجع حصص النهارده، وبعدين افتح المهام المسندة ليك.',
  'Started:': 'بدأ:',
  'Still to allocate: {0} EGP': 'المتبقي للتوزيع: {0} جنيه',
  'Stop live session': 'إيقاف الحصة المباشرة',
  'Student #': 'طالب رقم',
  'Student Code:': 'كود الطالب:',
  'Student Training Type (current:': 'نوع تدريب الطالب (الحالي:',
  'Student Transactions (': 'معاملات الطالب (',
  'Student attempt': 'محاولة الطالب',
  'Student attendance modes are stored per group membership.': 'طريقة حضور الطالب بتتسجل لكل عضوية في مجموعة.',
  'Student history is unavailable. Please contact support.': 'سجل الطالب مش متاح. تواصل مع الدعم.',
  'Student is approved. Changing course will transfer existing payments to the new course.': 'الطالب موافق عليه. تغيير الكورس هينقل المدفوعات الحالية للكورس الجديد.',
  'Student is pending. This will update the intended course.': 'الطالب قيد الانتظار. ده هيحدث الكورس المطلوب.',
  'Student pages': 'صفحات الطلاب',
  'Student {0}': 'الطالب {0}',
  'Students can attend remotely.': 'الطلاب يقدروا يحضروا أونلاين.',
  'Students must choose one of the selected branches.': 'الطلاب لازم يختاروا فرع من الفروع المحددة.',
  'Students results': 'نتائج الطلاب',
  'Submitting...': 'جاري الإرسال...',
  'Super Reception': 'مشرف الاستقبال',
  'Super reception can approve it, send it back as not yet, or mark it done wrong with feedback.': 'مشرف الاستقبال يقدر يوافق عليها، يرجعها كلسه مخلصتش، أو يسجلها اتنفذت غلط مع ملاحظاته.',
  'Task #': 'مهمة رقم',
  'Task folders are generated from active reception accounts. Add the new employee in Employee Records to create a folder, or deactivate employees who left to remove them from this view without deleting historical task records.': 'مجلدات المهام بتتعمل من حسابات الاستقبال النشطة. ضيف الموظف الجديد من سجلات الموظفين عشان يتعمله مجلد، أو عطّل حساب الموظف اللي مشي عشان يختفي من العرض ده من غير حذف سجل مهامه القديم.',
  'Task {0}': 'المهمة {0}',
  'Tasks for {0}': 'مهام {0}',
  'The dates, results, Trainer, CEO, and automatic certificate number become part of the permanent record.': 'التواريخ والنتائج والمدرب والمدير التنفيذي ورقم الشهادة التلقائي بيبقوا جزء من السجل الدائم.',
  'These actions affect': 'الإجراءات دي بتأثر على',
  'This action is destructive. Delete only if this exam has no important history.': 'الإجراء ده بيحذف البيانات. احذف الامتحان بس لو ملوش سجل مهم.',
  'This custom task will be accepted immediately.': 'المهمة المخصصة دي هتتقبل فورًا.',
  'This custom task will go to super reception for review.': 'المهمة المخصصة دي هتتبعت لمشرف الاستقبال للمراجعة.',
  'This group has no course assigned': 'المجموعة دي مفيش كورس محدد ليها',
  'This keeps the record but marks': 'ده بيحتفظ بالسجل وبيحدد',
  'This popup appears once per day and only highlights actionable work.': 'النافذة دي بتظهر مرة في اليوم وبتعرض الشغل اللي محتاج إجراء.',
  "This purchase adds this many sequential language levels to the student's package.": 'الشراء ده بيضيف العدد ده من مستويات اللغة المتتالية لباقة الطالب.',
  'This record could not be loaded for the current filters. Retry or adjust the filters.': 'مقدرناش نحمّل السجل بالفلاتر الحالية. حاول تاني أو عدل الفلاتر.',
  'This session date has passed. Only super reception can edit past sessions.': 'تاريخ الحصة دي فات. مشرف الاستقبال بس اللي يقدر يعدّل الحصص السابقة.',
  'This suggestion no longer exists.': 'الاقتراح ده مبقاش موجود.',
  'This waiting selection no longer exists.': 'اختيار الانتظار ده مبقاش موجود.',
  'This will change how students can access this exam.': 'ده هيغير طريقة وصول الطلاب للامتحان.',
  'Total Course Price': 'سعر الكورس بالكامل',
  'Total spent': 'إجمالي المصروف',
  'Training Type *': 'نوع التدريب *',
  'Transfer': 'تحويل',
  'Transfer TO (new course)': 'التحويل إلى (الكورس الجديد)',
  'Transfer student to group': 'تحويل الطالب لمجموعة',
  'Transfer {0} from {1} to another group for the same course.': 'تحويل {0} من {1} لمجموعة تانية لنفس الكورس.',
  'Transferring…': 'جاري التحويل…',
  'Try adjusting your filters to see more tasks.': 'جرب تعدّل الفلاتر عشان تشوف مهام أكتر.',
  'Try another language, level, type, or group filter.': 'جرب فلتر لغة أو مستوى أو نوع أو مجموعة مختلف.',
  'Type at least 2 letters, a student code, or phone number': 'اكتب حرفين على الأقل أو كود الطالب أو رقم الموبايل',
  'Unable to load request details.': 'مقدرناش نحمّل تفاصيل الطلب.',
  'Unable to load {0}.': 'مقدرناش نحمّل {0}.',
  'Unassigned instructor': 'المدرس مش محدد',
  'Unknown': 'غير معروف',
  'Unknown Exam': 'امتحان غير معروف',
  'Unknown guest': 'ضيف غير معروف',
  'Unknown lead': 'عميل محتمل غير معروف',
  'Unknown student': 'طالب غير معروف',
  'Unmarked / cancelled': 'غير مسجل / ملغي',
  'Unnamed student': 'طالب من غير اسم',
  'Unscheduled': 'غير مجدول',
  'Unscheduled balance:': 'الرصيد غير المجدول:',
  'Untitled entry': 'قيد من غير عنوان',
  'Untitled group': 'مجموعة من غير اسم',
  'Update Waiting': 'تحديث الانتظار',
  'Updating review...': 'جاري تحديث المراجعة...',
  'Updating…': 'جاري التحديث…',
  'Upload Material': 'رفع مادة',
  'Upload {0} Files': 'رفع {0} ملف',
  'Uploading...': 'جاري الرفع...',
  'Use approved amount (': 'استخدم المبلغ الموافق عليه (',
  'Use whole EGP amounts, up to': 'استخدم مبالغ بالجنيه من غير كسور، بحد أقصى',
  'View Details': 'عرض التفاصيل',
  'View Exam: {0}': 'عرض الامتحان: {0}',
  'View and manage employee daily report messages without losing handover context.': 'اعرض وأدر رسائل التقارير اليومية للموظفين مع الاحتفاظ بتفاصيل التسليم بين الشيفتات.',
  'View invoice {0}': 'عرض الفاتورة {0}',
  'Void Entry': 'إلغاء القيد',
  'Voiding...': 'جاري إلغاء القيد...',
  'Waiting Student': 'طالب في الانتظار',
  'Waiting for registration': 'في انتظار التسجيل',
  'Waiting for review': 'في انتظار المراجعة',
  'Walk-in': 'زيارة مباشرة',
  "We couldn't find any students matching your search criteria. Try adjusting your filters or check back later.": 'مفيش طلاب مطابقين للبحث. جرب تعدّل الفلاتر أو راجع تاني بعدين.',
  'WhatsApp link': 'رابط WhatsApp',
  'WhatsApp unavailable for {0}': 'WhatsApp مش متاح لـ {0}',
  'Writing prompt...': 'تعليمات سؤال الكتابة...',
  'You can edit this past session. Changes are logged for super reception review.': 'تقدر تعدّل الحصة السابقة دي. التغييرات بتتسجل عشان مشرف الاستقبال يراجعها.',
  'You currently have no assigned tasks.': 'مفيش مهام مسندة ليك حاليًا.',
  'You do not have access to this student’s history.': 'معندكش صلاحية تشوف سجل الطالب ده.',
  'accepts both in-person and online students.': 'بتقبل طلاب حضوري وأونلاين.',
  'accepts in-person students.': 'بتقبل طلاب حضوري.',
  'accepts online students.': 'بتقبل طلاب أونلاين.',
  'as correct': 'كإجابة صحيحة',
  'as not correct': 'كإجابة غير صحيحة',
  'deactivation': 'تعطيل',
  'deletion': 'حذف',
  'file': 'ملف',
  'items. Cards keep the important data visible without horizontal scroll.': 'عنصر. البطاقات بتعرض البيانات المهمة من غير تمرير أفقي.',
  'm': 'د',
  'on {0}': 'في {0}',
  'record': 'سجل',
  's': 'ث',
  'students |': 'طالب |',
  'the current level': 'المستوى الحالي',
  'the employee issuing this receipt': 'الموظف اللي بيصدر الإيصال ده',
  'this course': 'الكورس ده',
  'to {0}': 'إلى {0}',
  'was created. Next step: assign the group and schedule.': 'اتعمل. الخطوة الجاية: حدد المجموعة والمواعيد.',
  '{0} + Online': '{0} + أونلاين',
  '{0} / {1} levels consumed': '{0} / {1} مستوى مستخدم',
  '{0} Branch': 'فرع {0}',
  '{0} EGP': '{0} جنيه',
  '{0} Section': 'قسم {0}',
  '{0} attendance': 'حضور {0}',
  '{0} audio': 'صوت {0}',
  '{0} certificate{1}': '{0} شهادة{1}',
  '{0} installment(s) scheduled': '{0} قسط مجدول',
  '{0} loaded': 'تم تحميل {0}',
  '{0} options': '{0} اختيار',
  '{0} profile': 'ملف {0}',
  '{0} scheduled': 'تمت جدولة {0}',
  '{0} tabs': 'تبويبات {0}',
  '{0} | {1} | {2}/{3} students{4}{5}': '{0} | {1} | {2}/{3} طالب{4}{5}',
  '{0}% of total': '{0}% من الإجمالي',
  '| Speaking Max: {0}s': '| أقصى مدة للمحادثة: {0}ث',
  '· ID: {0}': '· المعرّف: {0}',
  '· Started at {0}': '· بدأ الساعة {0}',
  '✓ Got it': '✓ فهمت',
  'Overview': 'نظرة عامة',
  'Register Student': 'تسجيل طالب',
  'All Students': 'كل الطلاب',
  'Waiting Students': 'طلاب الانتظار',
  'Slots': 'المواعيد',
  'Queue': 'الطابور',
  'Administration & Reports': 'الإدارة والتقارير',
  'New Student': 'طالب جديد',
  'Daily Summary': 'ملخص اليوم',
  'Add at least one valid form field.': 'ضيف حقل صحيح واحد على الأقل للنموذج.',
  'Add Field': 'إضافة حقل',
  'Admin Workspace': 'مساحة الإدارة',
  'All Training Types': 'كل أنواع التدريب',
  'Approved Requests': 'الطلبات الموافق عليها',
  'Cancel Edit': 'إلغاء التعديل',
  'Classes': 'الدراسة',
  'Communication': 'التواصل',
  'Coupons Management': 'إدارة الكوبونات',
  'Create and manage summer programs from summer_programs only.': 'أنشئ وأدر البرامج الصيفية من سجل البرامج الصيفية بس.',
  'Create coupons tied to a university and faculty discount.': 'أنشئ كوبونات مرتبطة بخصم الجامعة والكلية.',
  'Create new program': 'إنشاء برنامج جديد',
  'Create sessions and mark attendance for scheduled groups.': 'أنشئ حصص وسجل الحضور للمجموعات المجدولة.',
  'Create the exact data schema students must submit.': 'حدد الحقول اللي لازم الطلاب يملوها.',
  'Delete Exam': 'حذف الامتحان',
  'Delivery': 'طريقة التقديم',
  'Enable notifications': 'تفعيل التنبيهات',
  'Enabling notifications': 'جاري تفعيل التنبيهات',
  'Enter form title': 'اكتب عنوان النموذج',
  'Enter program name': 'اكتب اسم البرنامج',
  'Event Certificates': 'شهادات الفعاليات',
  'Expense history': 'سجل المصروفات',
  'Failed to assign student to summer group': 'مقدرناش نضيف الطالب للمجموعة الصيفية',
  'Failed to create summer group': 'مقدرناش ننشئ المجموعة الصيفية',
  'Failed to create summer session': 'مقدرناش ننشئ الحصة الصيفية',
  'Failed to record summer payment': 'مقدرناش نسجل دفعة التدريب الصيفي',
  'Failed to send password setup link': 'مقدرناش نبعت رابط إعداد كلمة السر',
  'Finance': 'الحسابات',
  'Form Builder': 'إنشاء النماذج',
  'Form Details': 'تفاصيل النموذج',
  'Form Fields': 'حقول النموذج',
  'Group state': 'حالة المجموعة',
  'In a Group': 'في مجموعة',
  'Income history': 'سجل الدخل',
  'Lang Dashboard': 'لوحة متابعة اللغات',
  'Live view of summer registrations, groups, attendance, and payments.': 'عرض مباشر للتسجيلات الصيفية والمجموعات والحضور والمدفوعات.',
  'Manage registration forms and surveys for the summer session.': 'أدر نماذج التسجيل والاستبيانات للفترة الصيفية.',
  'New Registration': 'تسجيل جديد',
  'No fixed program': 'مفيش برنامج ثابت',
  'Organize and monitor student cohorts across active programs.': 'نظم وتابع دفعات الطلاب في البرامج النشطة.',
  'Payment voided and linked receipt marked voided.': 'الدفعة اتلغت والإيصال المرتبط اتسجل كملغي.',
  'Payments Management': 'إدارة المدفوعات',
  'Percent': 'نسبة مئوية',
  'Print receipt': 'طباعة الإيصال',
  'Programs Management': 'إدارة البرامج',
  'Public Link / Slug': 'الرابط العام / اسم الرابط',
  'Publish new form': 'نشر نموذج جديد',
  'Quarter': 'الربع السنوي',
  'Record payment': 'تسجيل دفعة',
  'Record payments and issue receipts for summer training only.': 'سجل المدفوعات وأصدر الإيصالات للتدريب الصيفي بس.',
  'Refunds': 'الاستردادات',
  'Registrations Management': 'إدارة التسجيلات',
  'Rejected Requests': 'الطلبات المرفوضة',
  'remaining': 'متبقي',
  'Remove field': 'إزالة الحقل',
  'Review and update summer trainee registration states.': 'راجع وحدث حالات تسجيل المتدربين الصيفيين.',
  'Scheduled Refunds': 'الاستردادات المجدولة',
  'Search by name, email, or ID number...': 'ابحث بالاسم أو الإيميل أو رقم الهوية...',
  'Search by registration, student, or program...': 'ابحث بالتسجيل أو الطالب أو البرنامج...',
  'Select at least one offline branch.': 'اختار فرع حضوري واحد على الأقل.',
  'Select faculty': 'اختار الكلية',
  'Select group': 'اختار المجموعة',
  'Select Online, Offline, or both.': 'اختار أونلاين أو حضوري أو الاتنين.',
  'Select program': 'اختار البرنامج',
  'Select registration': 'اختار التسجيل',
  'Select session': 'اختار الحصة',
  'Select Specific Group': 'اختار مجموعة محددة',
  'Select university': 'اختار الجامعة',
  'Select value': 'اختار القيمة',
  'Sort by: Latest': 'الترتيب: الأحدث',
  'Student assigned to summer group.': 'الطالب اتضاف للمجموعة الصيفية.',
  'Submission': 'التسليم',
  'Submission and amount are required.': 'لازم تحدد التسليم والمبلغ.',
  'Submission No.': 'رقم التسليم',
  'Submitted At': 'وقت التسليم',
  'Summer coupon created.': 'الكوبون الصيفي اتعمل.',
  'Summer form published.': 'النموذج الصيفي اتنشر.',
  'Summer form saved.': 'النموذج الصيفي اتحفظ.',
  'Summer form updated.': 'النموذج الصيفي اتحدث.',
  'Summer group created.': 'المجموعة الصيفية اتعملت.',
  'Summer program created.': 'البرنامج الصيفي اتعمل.',
  'Summer program updated.': 'البرنامج الصيفي اتحدث.',
  'Summer Season 2026': 'الموسم الصيفي 2026',
  'Summer session created.': 'الحصة الصيفية اتعملت.',
  'Super Logs': 'سجل مراجعة المشرف',
  'This Quarter': 'الربع السنوي الحالي',
  'This Year': 'السنة دي',
  'Trainee Name': 'اسم المتدرب',
  'Training Program': 'برنامج التدريب',
  'View All': 'عرض الكل',
  'Void reason prompt': 'طلب سبب الإلغاء',
  '{0} Statuses Selected': 'تم اختيار {0} حالة',
  '✓ Payment processed: {0} EGP\n{1}': '✓ الدفع اتسجل: {0} جنيه\n{1}',
  'Accountant notes': 'ملاحظات الحسابات',
  'Alternative phones': 'أرقام الموبايل البديلة',
  'Approval status': 'حالة الموافقة',
  'Approve {0} expense entries?': 'الموافقة على {0} قيد مصروفات؟',
  'Approve {0} income entries?': 'الموافقة على {0} قيد دخل؟',
  'Approved amount': 'المبلغ الموافق عليه',
  'Attendance mode': 'طريقة الحضور',
  'Author employee id': 'معرّف الموظف صاحب السجل',
  'Body': 'المحتوى',
  'Booking': 'حجز',
  'Booking created': 'الحجز اتعمل',
  'Branch transfer': 'تحويل فرع',
  'Calculated level': 'المستوى المحسوب',
  'Certificate': 'شهادة',
  'Certificate code': 'كود الشهادة',
  'Certificate revoked': 'صلاحية الشهادة اتلغت',
  'Completed at': 'وقت الاكتمال',
  'Completed count': 'عدد المكتمل',
  'Converted invoice id': 'معرّف الفاتورة المحولة',
  'Course id': 'معرّف الكورس',
  'Course interest': 'اهتمام بكورس',
  'Current job': 'الوظيفة الحالية',
  'Current level': 'المستوى الحالي',
  'Date not recorded': 'التاريخ مش متسجل',
  'Date of birth': 'تاريخ الميلاد',
  'Decision': 'القرار',
  'Delete "{0}"? This cannot be undone.': 'حذف "{0}"؟ مينفعش ترجع الحذف ده.',
  'Delete task "{0}"?': 'حذف المهمة "{0}"؟',
  'Deleted': 'اتحذف',
  'Delivery mode': 'طريقة التقديم',
  'Due date': 'تاريخ الاستحقاق',
  'Educational qualification': 'المؤهل الدراسي',
  'Enrollment': 'اشتراك',
  'Enrollment id': 'معرّف الاشتراك',
  'Event type': 'نوع الحدث',
  'Exam id': 'معرّف الامتحان',
  'Exam submitted': 'الامتحان اتسلم',
  'Failed to restore student': 'مقدرناش نرجّع الطالب',
  'Form no': 'رقم النموذج',
  'From branch': 'من فرع',
  'From group code': 'من كود مجموعة',
  'From group id': 'من معرّف مجموعة',
  'Full name': 'الاسم بالكامل',
  'Google followup done': 'متابعة Google خلصت',
  'Grade': 'الدرجة',
  'Group code': 'كود المجموعة',
  'Group id': 'معرّف المجموعة',
  'Installment': 'قسط',
  'Installment number': 'رقم القسط',
  'Intended course': 'الكورس المطلوب',
  'Invoice id': 'معرّف الفاتورة',
  'Invoice voided': 'الفاتورة اتلغت',
  'Is active': 'نشط',
  'Is approved': 'موافق عليه',
  'Is reviewed': 'اتراجع',
  'Issue waiver: {0} EGP original value, {1} EGP waiver, 0 EGP due. Issue directly?': 'إصدار إعفاء: القيمة الأصلية {0} جنيه، الإعفاء {1} جنيه، المستحق 0 جنيه. إصدار مباشر؟',
  'Join request': 'طلب انضمام',
  'Marketing status': 'حالة التسويق',
  'Max score': 'الدرجة القصوى',
  'Membership': 'عضوية',
  'New status': 'الحالة الجديدة',
  'Old status': 'الحالة القديمة',
  'Paid date': 'تاريخ الدفع',
  'Paid invoice id': 'معرّف الفاتورة المدفوعة',
  'Placement completed at': 'وقت اكتمال تحديد المستوى',
  'Placement test overridden': 'نتيجة اختبار تحديد المستوى اتجاوزت',
  'Profile completed': 'الملف مكتمل',
  'Progress status': 'حالة التقدم',
  'Provide a reason for rejecting this expense entry:': 'اكتب سبب رفض قيد المصروف ده:',
  'Provide a reason for rejecting this income entry:': 'اكتب سبب رفض قيد الدخل ده:',
  'Receipt kind': 'نوع الإيصال',
  'Reception notes': 'ملاحظات الاستقبال',
  'Reception status': 'حالة الاستقبال',
  'Refund accountant reviewed': 'الاسترداد اتراجع من الحسابات',
  'Refund completed': 'الاسترداد اكتمل',
  'Refund method': 'طريقة الاسترداد',
  'Refund reception reviewed': 'الاسترداد اتراجع من الاستقبال',
  'Refunded amount': 'المبلغ المسترد',
  'Remaining amount': 'المبلغ المتبقي',
  'Requested amount': 'المبلغ المطلوب',
  'Resolved group id': 'معرّف المجموعة المحددة',
  'Restore AND approve this student?': 'ترجيع الطالب والموافقة عليه؟',
  'Restore this student?': 'ترجيع الطالب ده؟',
  'Revoke reason': 'سبب إلغاء الصلاحية',
  'Revoked at': 'وقت إلغاء الصلاحية',
  'Scheduled refund date': 'تاريخ الاسترداد المجدول',
  'Sender role': 'دور المرسل',
  'Session id': 'معرّف الحصة',
  'Student activated': 'حساب الطالب اتفعل',
  'Student added to group': 'الطالب اتضاف لمجموعة',
  'Student branch transferred': 'فرع الطالب اتغير',
  'Student comment deleted': 'تعليق الطالب اتحذف',
  'Student course changed': 'كورس الطالب اتغير',
  'Student course transferred': 'الطالب اتحول لكورس تاني',
  'Student deactivated': 'حساب الطالب اتعطل',
  'Student level set': 'مستوى الطالب اتحدد',
  'Student moved group': 'الطالب اتنقل لمجموعة تانية',
  'Student progress updated': 'تقدم الطالب اتحدث',
  'Student removed from group': 'الطالب اتشال من المجموعة',
  'Student removed from groups for waiting': 'الطالب اتشال من المجموعات للانتظار',
  'Students moved group batch': 'طلاب اتنقلوا دفعة واحدة لمجموعة تانية',
  'Submitted at': 'وقت التسليم',
  'Task approved': 'المهمة اتوافق عليها',
  'Task comment added': 'تعليق اتضاف للمهمة',
  'Task event': 'حدث مهمة',
  'Task id': 'معرّف المهمة',
  'Task rejected': 'المهمة اترفضت',
  'Task status changed': 'حالة المهمة اتغيرت',
  'Task submitted': 'المهمة اتسلمت',
  'Text': 'النص',
  'Ticket number': 'رقم التذكرة',
  'To branch': 'إلى فرع',
  'To group code': 'إلى كود مجموعة',
  'To group id': 'إلى معرّف مجموعة',
  'Total amount': 'المبلغ الإجمالي',
  'Total score': 'الدرجة الإجمالية',
  'Voided at': 'وقت إلغاء القيد',
  'Whatsapp': 'WhatsApp',
  'Retry failed AI grading': 'إعادة تصحيح الإجابات اللي فشلت',
  'Retry AI grading': 'إعادة التصحيح بالـAI',
  'AI grading failed': 'تصحيح الـAI فشل',
  'Retrying...': 'بنعيد التصحيح...',
  'AI grading could not be restarted. Please try again later.': 'مش قادرين نبدأ التصحيح تاني دلوقتي. جرّب كمان شوية.',
  'WorkMail user': 'مستخدم بريد العمل',
  'General Manager': 'المدير العام',
  'Developer': 'المطور',
  'Sales Manager (sender is sales)': 'مدير المبيعات (المرسل من المبيعات)',
  'Failed to load mail center': 'تعذر تحميل مركز البريد',
  'Failed to load conversations': 'تعذر تحميل المحادثات',
  'Failed to load messages': 'تعذر تحميل الرسائل',
  'Failed to remove attachment': 'تعذر حذف المرفق',
  'Failed to upload attachments': 'تعذر رفع المرفقات',
  'Subject is required': 'عنوان الرسالة مطلوب',
  'Message body is required': 'نص الرسالة مطلوب',
  'Choose at least one recipient': 'اختر مستلمًا واحدًا على الأقل',
  'Failed to send message': 'تعذر إرسال الرسالة',
  'Message sent': 'تم إرسال الرسالة',
  'Select a conversation first': 'اختر محادثة أولًا',
  'Reply body is required': 'نص الرد مطلوب',
  'Failed to send reply': 'تعذر إرسال الرد',
  'Mailbox action failed': 'تعذر تنفيذ أمر صندوق البريد',
  'Inbox': 'الوارد',
  'Received mail': 'الرسائل المستلمة',
  'Messages you sent': 'الرسائل التي أرسلتها',
  'Hidden from inbox': 'مخفية من الوارد',
  'Trash': 'المحذوفات',
  'Recently deleted': 'المحذوف مؤخرًا',
  'All Mail': 'كل البريد',
  'All active conversations': 'كل المحادثات النشطة',
  'Connected': 'متصل',
  'Connecting': 'جارٍ الاتصال',
  'Remove {0}': 'حذف {0}',
  'Attach images, videos, or documents': 'أرفق صورًا أو فيديوهات أو مستندات',
  'Attach': 'إرفاق',
  'CC': 'نسخة إلى',
  'Employee, email, alias, or emp:ID': 'موظف أو بريد أو اسم مختصر أو رقم موظف',
  'Optional recipients': 'مستلمون اختياريون',
  'Select a message': 'اختر رسالة',
  'Choose a conversation from {0}': 'اختر محادثة من {0}',
  'Loading messages...': 'جارٍ تحميل الرسائل...',
  'No messages yet.': 'لا توجد رسائل بعد.',
  'Unknown sender': 'مرسل غير معروف',
  'You': 'أنت',
  'Employee {0}': 'موظف {0}',
  'Write a reply...': 'اكتب ردًا...',
  'Send reply': 'إرسال الرد',
  'Auto-CC': 'نسخة تلقائية',
  'Attachments': 'المرفقات',
  'Move to Inbox': 'نقل إلى الوارد',
  'Move to Trash': 'نقل إلى المحذوفات',
  'Close message': 'إغلاق الرسالة',
  '{0} unread': '{0} غير مقروءة',
  'Auto-CC enabled': 'النسخة التلقائية مفعلة',
  'Explicit recipients only': 'المستلمون المحددون فقط',
  'Compose': 'رسالة جديدة',
  'Search mail': 'البحث في البريد',
  'Folders': 'المجلدات',
  'Auto CC': 'نسخة تلقائية',
  'Sales Manager CC applies only for sales senders.': 'تُضاف نسخة لمدير المبيعات فقط عندما يكون المرسل من المبيعات.',
  '{0} conversations': '{0} محادثة',
  'No conversations': 'لا توجد محادثات',
  'This folder is empty.': 'هذا المجلد فارغ.',
  'No message preview': 'لا توجد معاينة للرسالة',
  'New Message': 'رسالة جديدة',
  'Auto-CC is applied on send': 'تُضاف النسخة التلقائية عند الإرسال',
  'Close composer': 'إغلاق محرر الرسالة',
  'Write a subject': 'اكتب عنوان الرسالة',
  'Write your message...': 'اكتب رسالتك...',
  '{0} characters': '{0} حرف',
  'Move conversation to Trash?': 'نقل المحادثة إلى المحذوفات؟',
  'You can restore this conversation from Trash.': 'يمكنك استعادة هذه المحادثة من المحذوفات.',
  'Yes, move to Trash': 'نعم، انقل إلى المحذوفات',
  '(No subject)': '(بدون عنوان)',
  'Close create session': 'إغلاق إنشاء الحصة',
  'Multiple Choice': 'اختيار من متعدد',
  'True False': 'صح أو خطأ',
  'Question {0} text': 'نص السؤال {0}',
  'Question {0} score': 'درجة السؤال {0}',
  'Question {0} explanation': 'شرح السؤال {0}',
  'Question {0} image': 'صورة السؤال {0}',
  'Option {0} text': 'نص الاختيار {0}',
  'Missing title': 'العنوان غير مكتمل',
  'No file selected': 'لم يتم اختيار ملف',
  'Choose an Excel file with the name and phone number.': 'اختر ملف Excel الذي يحتوي على الاسم ورقم الهاتف.',
  '{0} certificates were prepared from the Excel file.': 'تم تجهيز {0} شهادة من ملف Excel.',
  'When importing an exam, include the correct answer for each multiple-choice question.': 'عند استيراد امتحان، أضف الإجابة الصحيحة لكل سؤال اختيار من متعدد.',
  'Unable to load task summary.': 'تعذر تحميل ملخص المهام.',
};
